const ApiGatewayHubUrl = `https://${process.env.REACT_APP_APIGATEWAY_HOST}`;

export const SignalRHubs = {
  ApiGatewayHub: `${ApiGatewayHubUrl}/hub/notificationhub`,
};
